import React, { useState } from 'react';
import { ReactComponent as LowpassIcon } from '../assets/icons/lowpass.svg';
import { ReactComponent as HighpassIcon } from '../assets/icons/highpass.svg';
import { ReactComponent as BandpassIcon } from '../assets/icons/bandpass.svg';
import { ReactComponent as LowshelfIcon } from '../assets/icons/lowshelf.svg';
import { ReactComponent as HighshelfIcon } from '../assets/icons/highshelf.svg';
import { ReactComponent as PeakingIcon } from '../assets/icons/peaking.svg';
import { ReactComponent as NotchIcon } from '../assets/icons/notch.svg';
import { ReactComponent as AllpassIcon } from '../assets/icons/allpass.svg';

const filterOptions = [
    { value: "lowpass", label: "Lowpass", icon: <LowpassIcon width="20" height="20" /> },
    { value: "highpass", label: "Highpass", icon: <HighpassIcon width="20" height="20" /> },
    { value: "bandpass", label: "Bandpass", icon: <BandpassIcon width="20" height="20" /> },
    { value: "lowshelf", label: "Lowshelf", icon: <LowshelfIcon width="20" height="20" /> },
    { value: "highshelf", label: "Highshelf", icon: <HighshelfIcon width="20" height="20" /> },
    { value: "peaking", label: "Peaking", icon: <PeakingIcon width="20" height="20" /> },
    { value: "notch", label: "Notch", icon: <NotchIcon width="20" height="20" /> },
    { value: "allpass", label: "Allpass", icon: <AllpassIcon width="20" height="20" /> },
];


const Dropdown = ({ value, index,  onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const selectedOption = filterOptions.find(option => option.value === value);

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false); // Close dropdown after selecting
    };

    return (
        <div className="custom-dropdown">
            <button 
                className="dropdown-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedOption.icon} {index + 1} ▼
            </button>
            
            {isOpen && (
                <ul className="dropdown-list">
                    {filterOptions.map((option) => (
                        <li 
                            key={option.value} 
                            onClick={() => handleSelect(option)}
                            className="dropdown-item"
                        >
                            {option.icon} 
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
